import { object, string } from "yup";

export const createPropertyFormSchema = (hasPropertyOwner: boolean) => {
  return object({
    name: string().required("Property name and address cannot be empty"),
    owner: hasPropertyOwner
      ? string().required("Owner is required")
      : string().optional(),
    externalId: string().optional(),
    address1: string().required("Street address is required"),
    address2: string().optional(),
    city: string().required("City is required"),
    state_or_province: string().required("State is required"),
    postal_code: string().required("Zip code is required"),
    country: string().required("Country is required")
  });
};
